import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import ItemCard from '../../../../components/ItemCard';
import PickItemParcels from './PickItemParcels';
import PickItemProperty from './PickItemProperty';
import PickItemQuantityCounter from './PickItemQuantityCounter';
import ProductDialog from '../../../../components/ProductDialog';
import translations from './translations';

const PickItem = ({ item, itemKey, itemQuantityCounter, showPacking }) => {
  const intl = useIntl();
  const [showProductDialog, setShowProductDialog] = useState(false);
  const itemQuantity = itemQuantityCounter?.itemQuantities[itemKey]?.quantity ?? 0;

  const handleShowProductDialog = () => {
    setShowProductDialog(true);
  };

  const handleCloseProductDialog = () => {
    setShowProductDialog(false);
  };

  return (
    <>
      {showPacking && (
        <Hidden smDown implementation="js">
          <PickItemParcels item={item} itemQuantity={itemQuantity} />
          <Box py={2}>
            <Divider />
          </Box>
        </Hidden>
      )}
      <ItemCard item={item} onClick={handleShowProductDialog} />
      <Box flex={1} p={2}>
        <PickItemProperty
          label={intl.formatMessage(translations.properties.position)}
          value={item.position}
        />

        {item?.sorting_label && (
          <Box my={2}>
            <PickItemProperty
              label={intl.formatMessage(translations.properties.crate)}
              value={item.sorting_label}
            />
          </Box>
        )}
      </Box>
      <PickItemQuantityCounter counter={itemQuantityCounter} itemKey={itemKey} />
      {showPacking && (
        <Hidden mdUp implementation="js">
          <Box py={1}>
            <PickItemParcels item={item} itemQuantity={itemQuantity} />
          </Box>
        </Hidden>
      )}
      <ProductDialog
        isOpen={showProductDialog}
        onClose={handleCloseProductDialog}
        product={item?.product}
      />
    </>
  );
};

PickItem.propTypes = {
  item: PropTypes.object.isRequired,
  itemKey: PropTypes.string.isRequired,
  itemQuantityCounter: PropTypes.object.isRequired,
  showPacking: PropTypes.bool,
};

PickItem.defaultProps = {
  showPacking: false,
};

export default PickItem;
